import { Box } from "@chakra-ui/react";

export const MagicBox = () => (
  <Box w="100%" h="100%" position="absolute">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Shape"
        fill="#6400b3"
        fill-rule="evenodd"
        stroke="none"
        d="M 0 1000 L 0 604 L 56 604 C 86.927872 604 112 557.4375 112 500 C 112 442.562561 86.927872 396 56 396 L 0 396 L 0 0 L 396 0 L 396 56 C 396 86.927917 442.562408 112 500 112 C 557.437561 112 604 86.927917 604 56 L 604 0 L 1000 0 L 1000 396 L 944 396 C 913.072266 396 888 442.562622 888 500 C 888 557.437378 913.072266 604 944 604 L 1000 604 L 1000 1000 L 604 1000 L 604 944 C 604 913.072083 557.4375 888 500 888 C 442.562469 888 396 913.072083 396 944 L 396 1000 L 0 1000 Z"
      />
      <mask
        id="magicboxmask1"
        maskUnits="userSpaceOnUse"
        maskContentUnits="userSpaceOnUse"
        mask-type="alpha"
      >
        <path
          id="path1"
          fill="#6400b3"
          fill-rule="evenodd"
          stroke="none"
          d="M 0 1000 L 0 604 L 56 604 C 86.927872 604 112 557.4375 112 500 C 112 442.562561 86.927872 396 56 396 L 0 396 L 0 0 L 396 0 L 396 56 C 396 86.927917 442.562408 112 500 112 C 557.437561 112 604 86.927917 604 56 L 604 0 L 1000 0 L 1000 396 L 944 396 C 913.072266 396 888 442.562622 888 500 C 888 557.437378 913.072266 604 944 604 L 1000 604 L 1000 1000 L 604 1000 L 604 944 C 604 913.072083 557.4375 888 500 888 C 442.562469 888 396 913.072083 396 944 L 396 1000 L 0 1000 Z"
        />
      </mask>
      <g id="Group" mask="url(#magicboxmask1)">
        <g id="g1">
          <path
            id="Star"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 316.588501 28.175415 L 294.912811 65.538452 L 250.896164 73.621887 L 281.516479 104.796936 L 275.988403 147.155823 L 316.588501 129.059998 L 357.188599 147.155823 L 351.660522 104.796936 L 382.280823 73.621887 L 338.264191 65.538452 Z"
          />
          <path
            id="Star-copy-16"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 849.588501 576.175415 L 827.912781 613.538452 L 783.896179 621.621887 L 814.516479 652.796936 L 808.988403 695.155762 L 849.588501 677.060059 L 890.188599 695.155762 L 884.660522 652.796936 L 915.280823 621.621887 L 871.264221 613.538452 Z"
          />
          <path
            id="Star-copy-13"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 275.588501 671.175415 L 253.912796 708.538452 L 209.896164 716.621887 L 240.516495 747.796936 L 234.988403 790.155762 L 275.588501 772.059998 L 316.188599 790.155762 L 310.660522 747.796936 L 341.280823 716.621887 L 297.264191 708.538452 Z"
          />
          <path
            id="Star-copy-7"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 421.786194 154.139465 L 414.196594 196.66272 L 375.599182 219.313232 L 415.03537 238.135437 L 424.328247 279.830444 L 456.290741 248.939941 L 500.6315 252.05835 L 480.949188 214.144775 L 499.060394 174.377075 L 454.933594 181.835693 Z"
          />
          <path
            id="Star-copy"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 102.573074 32.843628 L 94.98349 75.366882 L 56.386074 98.017395 L 95.822266 116.8396 L 105.115143 158.534607 L 137.077637 127.644104 L 181.418365 130.762512 L 161.736084 92.848938 L 179.84729 53.081177 L 135.720474 60.539856 Z"
          />
          <path
            id="Star-copy-3"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 179.575089 192.505615 L 186.98703 235.060242 L 158.464264 269.545837 L 201.959732 273.744934 L 224.952713 309.747131 L 244.422455 269.78772 L 287.15567 257.552612 L 255.693161 228.657227 L 259.110748 185.093445 L 220.196121 207.194519 Z"
          />
          <path
            id="Star-copy-21"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 9.403719 172.040649 L 1.814133 214.563904 L -36.783283 237.214417 L 2.652911 256.036621 L 11.945786 297.731628 L 43.908276 266.841125 L 88.249016 269.959534 L 68.566727 232.045959 L 86.677925 192.278259 L 42.551117 199.736877 Z"
          />
          <path
            id="Star-copy-6"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 719.732666 118.981628 L 727.144653 161.536194 L 698.621887 196.021851 L 742.11731 200.220947 L 765.110291 236.223083 L 784.580078 196.263672 L 827.313293 184.028625 L 795.850769 155.13324 L 799.268372 111.569397 L 760.353699 133.670471 Z"
          />
          <path
            id="Star-copy-22"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 882.389038 2.541809 L 874.799438 45.065125 L 836.202026 67.715637 L 875.638184 86.537842 L 884.931091 128.232849 L 916.893555 97.342346 L 961.234314 100.460754 L 941.552002 62.54718 L 959.663208 22.779419 L 915.536438 30.238037 Z"
          />
          <path
            id="Star-copy-20"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M -3.267305 778.981628 L 4.144633 821.536255 L -24.378138 856.021851 L 19.117331 860.220947 L 42.110313 896.223083 L 61.580051 856.263672 L 104.313278 844.028625 L 72.850769 815.13324 L 76.268364 771.569397 L 37.353725 793.670471 Z"
          />
          <path
            id="Star-copy-10"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 652.732666 686.834106 L 660.144653 729.388733 L 631.621887 763.87439 L 675.11731 768.073486 L 698.110291 804.075623 L 717.580078 764.116211 L 760.313293 751.881104 L 728.850769 722.985718 L 732.268372 679.421875 L 693.353699 701.522949 Z"
          />
          <path
            id="Star-copy-31"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 910.732666 839.834106 L 918.144653 882.388733 L 889.621887 916.87439 L 933.11731 921.073486 L 956.110291 957.075623 L 975.580078 917.116211 L 1018.313293 904.881104 L 986.850769 875.985718 L 990.268372 832.421936 L 951.353699 854.52301 Z"
          />
          <path
            id="Star-copy-5"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 597.441406 253.723816 L 575.765686 291.086792 L 531.749084 299.170227 L 562.369385 330.345276 L 556.841309 372.704163 L 597.441406 354.608337 L 638.041504 372.704163 L 632.513428 330.345276 L 663.133728 299.170227 L 619.117126 291.086792 Z"
          />
          <path
            id="Star-copy-32"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 977.441406 132.723816 L 955.765686 170.086792 L 911.749084 178.170227 L 942.369385 209.345276 L 936.841309 251.704163 L 977.441406 233.608337 L 1018.041504 251.704163 L 1012.513428 209.345276 L 1043.133789 178.170227 L 999.117126 170.086792 Z"
          />
          <path
            id="Star-copy-15"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 585.104187 85.683105 L 577.514587 128.20636 L 538.917175 150.856934 L 578.353394 169.679077 L 587.64624 211.374146 L 619.608765 180.483582 L 663.949524 183.60199 L 644.267212 145.688416 L 662.378418 105.920715 L 618.251587 113.379333 Z"
          />
          <path
            id="Star-copy-9"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 258.515472 499.515778 L 236.839783 536.878784 L 192.823135 544.96228 L 223.443481 576.137268 L 217.91539 618.496094 L 258.515472 600.400391 L 299.115601 618.496094 L 293.587494 576.137268 L 324.207825 544.96228 L 280.191193 536.878784 Z"
          />
          <path
            id="Star-copy-12"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 285.879791 302.200378 L 293.291718 344.755005 L 264.768951 379.240601 L 308.264435 383.439758 L 331.257416 419.441895 L 350.727142 379.482483 L 393.460358 367.247375 L 361.997864 338.352051 L 365.415466 294.788208 L 326.500824 316.889282 Z"
          />
          <path
            id="Star-copy-25"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 703.283386 500.272522 L 681.607727 537.635498 L 637.591064 545.718994 L 668.211426 576.894043 L 662.683289 619.25293 L 703.283386 601.157104 L 743.883484 619.25293 L 738.355408 576.894043 L 768.975769 545.718994 L 724.959106 537.635498 Z"
          />
          <path
            id="Star-copy-24"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 410.575104 649.505615 L 417.98703 692.060181 L 389.464264 726.545898 L 432.959717 730.744995 L 455.952698 766.747131 L 475.422455 726.78772 L 518.155701 714.552612 L 486.693176 685.657227 L 490.110748 642.093384 L 451.196136 664.194458 Z"
          />
          <path
            id="Star-copy-23"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 505.879791 779.200439 L 513.291748 821.755005 L 484.768951 856.240601 L 528.264404 860.439697 L 551.257385 896.441895 L 570.727173 856.482483 L 613.460388 844.247375 L 581.997864 815.352051 L 585.415466 771.788208 L 546.500793 793.889282 Z"
          />
          <path
            id="Star-copy-17"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 815.879761 244.200378 L 823.291748 286.755005 L 794.768982 321.240601 L 838.264404 325.439758 L 861.257385 361.441895 L 880.727173 321.482483 L 923.460388 309.247375 L 891.997864 280.352051 L 895.415466 236.788208 L 856.500793 258.889282 Z"
          />
          <path
            id="Star-copy-8"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 91.037788 626.492981 L 98.44973 669.047607 L 69.926956 703.533203 L 113.422424 707.7323 L 136.415405 743.734497 L 155.885147 703.775024 L 198.618378 691.539978 L 167.155869 662.644653 L 170.573456 619.080811 L 131.658813 641.181885 Z"
          />
          <path
            id="Star-copy-30"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 759.046753 796.67749 L 780.566223 834.130737 L 765.55835 876.291992 L 807.866882 865.361511 L 841.786682 891.328369 L 846.415344 847.119751 L 882.38678 821.006958 L 842.938904 804.61499 L 831.250671 762.509521 L 802.241882 796.58728 Z"
          />
          <path
            id="Star-copy-29"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 698.842834 913.187012 L 691.253235 955.710266 L 652.655823 978.36084 L 692.092041 997.182983 L 701.384888 1038.878052 L 733.347412 1007.987488 L 777.68811 1011.105957 L 758.005859 973.192322 L 776.117065 933.424622 L 731.990234 940.88324 Z"
          />
          <path
            id="Star-copy-27"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 362.842834 818.187012 L 355.253235 860.710327 L 316.655823 883.36084 L 356.09201 902.182983 L 365.384888 943.878052 L 397.347382 912.987488 L 441.688141 916.105957 L 422.005829 878.192322 L 440.117035 838.424622 L 395.990234 845.88324 Z"
          />
          <path
            id="Star-copy-28"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 165.842834 838.187012 L 158.25325 880.710266 L 119.65583 903.36084 L 159.092026 922.182983 L 168.384903 963.878052 L 200.347397 932.987488 L 244.688126 936.105957 L 225.005844 898.192322 L 243.117035 858.424622 L 198.990234 865.88324 Z"
          />
          <path
            id="Star-copy-14"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 731.842834 352.187012 L 724.253235 394.710266 L 685.655823 417.36084 L 725.092041 436.182983 L 734.384888 477.878052 L 766.347412 446.987488 L 810.68811 450.105896 L 791.005859 412.192322 L 809.117065 372.424622 L 764.990234 379.88324 Z"
          />
          <path
            id="Star-copy-2"
            fill="#39caff"
            fill-rule="evenodd"
            stroke="none"
            d="M 99.58065 379.436646 L 121.100121 416.889832 L 106.09227 459.051086 L 148.400818 448.120667 L 182.320618 474.087524 L 186.949265 429.878967 L 222.920715 403.766113 L 183.472824 387.374146 L 171.784607 345.268677 L 142.775818 379.346436 Z"
          />
        </g>
      </g>
      <path
        id="Rectangle-copy"
        fill="none"
        stroke="#ffeb39"
        stroke-width="20"
        stroke-linecap="round"
        d="M 990 386.03125 L 939.328125 386.203125 L 931.828125 387.796875 L 924.84375 390.625 L 918.328125 394.546875 L 912.28125 399.46875 L 905.46875 406.734375 L 898.296875 416.9375 L 892.109375 428.6875 L 887.34375 440.6875 L 883.21875 454.8125 L 880.21875 470 L 878.453125 486.03125 L 878 500 L 878.453125 513.953125 L 880.21875 529.984375 L 883.21875 545.171875 L 887.34375 559.296875 L 892.109375 571.296875 L 898.296875 583.046875 L 905.46875 593.25 L 912.28125 600.515625 L 918.328125 605.4375 L 924.84375 609.359375 L 931.828125 612.1875 L 939.328125 613.78125 L 990 613.96875 L 990 990 L 613.96875 990 L 613.78125 939.328125 L 612.1875 931.828125 L 609.359375 924.84375 L 605.4375 918.328125 L 600.515625 912.28125 L 593.25 905.46875 L 583.046875 898.296875 L 571.296875 892.109375 L 559.296875 887.34375 L 545.171875 883.21875 L 529.984375 880.21875 L 513.953125 878.453125 L 500 878 L 486.03125 878.453125 L 470 880.21875 L 454.8125 883.21875 L 440.6875 887.34375 L 428.6875 892.109375 L 416.9375 898.296875 L 406.734375 905.46875 L 399.46875 912.28125 L 394.546875 918.328125 L 390.625 924.84375 L 387.796875 931.828125 L 386.203125 939.328125 L 386.03125 990 L 10 990 L 10 613.96875 L 60.65625 613.78125 L 68.15625 612.1875 L 75.140625 609.359375 L 81.65625 605.4375 L 87.703125 600.515625 L 94.515625 593.25 L 101.6875 583.046875 L 107.875 571.296875 L 112.640625 559.296875 L 116.765625 545.171875 L 119.765625 529.984375 L 121.53125 513.953125 L 122 500 L 121.53125 486.03125 L 119.765625 470 L 116.765625 454.8125 L 112.640625 440.6875 L 107.875 428.6875 L 101.6875 416.9375 L 94.515625 406.734375 L 87.703125 399.46875 L 81.65625 394.546875 L 75.140625 390.625 L 68.15625 387.796875 L 60.65625 386.203125 L 10 386.03125 L 10 10 L 386.03125 10 L 386.203125 60.65625 L 387.796875 68.15625 L 390.625 75.140625 L 394.546875 81.65625 L 399.46875 87.703125 L 406.734375 94.515625 L 416.9375 101.6875 L 428.6875 107.875 L 440.6875 112.640625 L 454.8125 116.765625 L 470 119.765625 L 486.03125 121.53125 L 500 122 L 513.953125 121.53125 L 529.984375 119.765625 L 545.171875 116.765625 L 559.296875 112.640625 L 571.296875 107.875 L 583.046875 101.6875 L 593.25 94.515625 L 600.515625 87.703125 L 605.4375 81.65625 L 609.359375 75.140625 L 612.1875 68.15625 L 613.78125 60.65625 L 613.96875 10 L 990 10 Z"
      />
      <path
        id="Star-copy-18"
        fill="#ffeb39"
        fill-rule="evenodd"
        stroke="none"
        d="M 499.257751 353.028442 L 450.698303 436.731689 L 352.089111 454.84082 L 420.686951 524.681335 L 408.302521 619.57666 L 499.257751 579.037231 L 590.212952 619.57666 L 577.828552 524.681335 L 646.426392 454.84082 L 547.817139 436.731689 Z"
      />
    </svg>
  </Box>
);
